/**
 * Name: @redventures/beam
 * Version: 1.4.4
 */
(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
      (global = global || self, global._Beam = factory());
}(this, (function () { 'use strict';

  function _typeof(obj) {
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
      _typeof = function (obj) {
        return typeof obj;
      };
    } else {
      _typeof = function (obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
      };
    }

    return _typeof(obj);
  }

  function _defineProperty(obj, key, value) {
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }

    return obj;
  }

  function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
  }

  function _toConsumableArray(arr) {
    return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
  }

  function _arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) {
      for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

      return arr2;
    }
  }

  function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
  }

  function _iterableToArray(iter) {
    if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
  }

  function _iterableToArrayLimit(arr, i) {
    if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
      return;
    }

    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;

    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);

        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"] != null) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }

    return _arr;
  }

  function _nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance");
  }

  function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance");
  }

  /**
   * Default schemas
   * @see https://app.make.rvapps.io/
   */
    // ----------
    // Primitives
    // ----------
  var INTEGER = {
      type: 'integer',
      required: false
    };
  var NUMBER = {
    type: 'number',
    required: false
  };
  var STRING = {
    type: 'string',
    required: false
  };
  var BOOLEAN = {
    type: 'boolean',
    required: false
  }; // -------
  // Complex
  // -------

  var ARRAY_OF_STRINGS = {
    type: 'array',
    required: false,
    items: STRING
  };
  var FILTER = {
    type: 'object',
    required: false,
    properties: {
      type: STRING,
      value: STRING
    }
  };
  var FORM_CONTEXT = {
    type: 'object',
    required: false,
    properties: {
      formName: STRING,
      formId: STRING,
      formType: STRING
    }
  };
  var PRODUCT = {
    type: 'object',
    required: false,
    properties: {
      brand: STRING,
      category: STRING,
      coupon: STRING,
      formatSubtype: STRING,
      formatType: STRING,
      location: STRING,
      name: STRING,
      pageId: STRING,
      position: INTEGER,
      price: NUMBER,
      productId: STRING,
      quantity: INTEGER,
      sku: STRING,
      subscription: {
        type: 'object',
        required: false,
        properties: {
          frequency: STRING
        }
      },
      text: STRING,
      upc: STRING,
      variant: STRING
    }
  };
  var STEP_CONTEXT = {
    type: 'object',
    required: false,
    properties: {
      stepId: STRING,
      stepName: STRING,
      stepType: STRING
    }
  };
  var FIELD = {
    type: 'object',
    required: false,
    properties: {
      autofilled: BOOLEAN,
      fieldId: STRING,
      fieldLabel: STRING,
      fieldName: STRING,
      fieldType: STRING,
      fieldValue: STRING
    }
  };
  var WEB_ELEMENT = {
    type: 'object',
    required: false,
    properties: {
      elementType: STRING,
      htmlId: STRING,
      location: STRING,
      name: STRING,
      position: STRING,
      text: STRING
    }
  };
  var schemas = {
    Alias: {
      type: STRING,
      alias: STRING
    },
    ApplicationClicked: {
      actionOutcome: STRING,
      applicationType: STRING,
      webElement: WEB_ELEMENT
    },
    CartViewed: {},
    CheckoutStarted: {},
    ContentMetadataTracked: {
      author: STRING,
      category: STRING,
      contentName: STRING,
      funnelStage: STRING,
      lastRefreshDate: STRING,
      objective: ARRAY_OF_STRINGS,
      publishDate: STRING,
      siteSection: STRING,
      tags: ARRAY_OF_STRINGS,
      targetAudience: STRING
    },
    ElementClicked: {
      actionOutcome: STRING,
      correlationId: STRING,
      outboundUrl: STRING,
      webElement: WEB_ELEMENT
    },
    ElementSwiped: {
      actionOutcome: STRING,
      webElement: WEB_ELEMENT
    },
    ElementViewed: {
      webElement: WEB_ELEMENT
    },
    FieldInputted: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT,
      userInputField: FIELD
    },
    FieldSelected: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT,
      userInputField: FIELD
    },
    FormBacked: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormContinued: {
      autofillUsed: BOOLEAN,
      correlationId: STRING,
      field: FIELD,
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormErrored: {
      errorDetails: STRING,
      errorMessage: STRING,
      errorType: STRING,
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormExited: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormOutcomeReceived: {
      correlationId: STRING,
      formContext: FORM_CONTEXT,
      outboundUrl: STRING,
      responseDescription: STRING,
      responseMessage: STRING
    },
    FormRestarted: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormStarted: {
      correlationId: STRING,
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    FormSubmitted: {
      autofillUsed: BOOLEAN,
      correlationId: STRING,
      field: {
        type: 'array',
        required: false,
        items: FIELD
      },
      formContext: FORM_CONTEXT,
      outboundUrl: STRING,
      stepContext: STEP_CONTEXT
    },
    FormViewed: {
      formContext: FORM_CONTEXT,
      stepContext: STEP_CONTEXT
    },
    HopPageViewed: {
      affiliateId: INTEGER,
      categoryId: INTEGER,
      correlationId: STRING,
      omnitureId: INTEGER,
      omnitureIdString: STRING,
      pageId: INTEGER,
      position: STRING,
      productId: INTEGER,
      purchaseId: INTEGER
    },
    ListFiltered: {
      listId: STRING,
      listName: STRING,
      listType: STRING,
      location: STRING,
      position: STRING,
      value: STRING
    },
    PageErrored: {
      errorMessage: STRING,
      errorType: STRING,
      urlEntered: STRING
    },
    PageScrolled: {
      scrollDistance: NUMBER
    },
    PageViewed: {},
    PageEngaged: {
      engagementDuration: INTEGER,
      totalDuration: INTEGER
    },
    ProductAdded: {
      correlationId: STRING,
      listId: STRING,
      product: PRODUCT
    },
    ProductClicked: {
      actionOutcome: STRING,
      correlationId: STRING,
      listId: STRING,
      outboundUrl: STRING,
      product: PRODUCT,
      viewCorrelationId: STRING
    },
    ProductListFiltered: {
      field: {
        type: 'array',
        required: false,
        items: FIELD
      },
      filters: {
        type: 'array',
        required: false,
        items: FILTER
      },
      listId: INTEGER,
      product: {
        type: 'array',
        required: false,
        items: PRODUCT
      },
      sorts: {
        type: 'array',
        required: false,
        items: FILTER
      }
    },
    ProductListViewed: {
      category: STRING,
      editorialListings: INTEGER,
      featuredListings: INTEGER,
      field: {
        type: 'array',
        required: false,
        items: FIELD
      },
      listId: STRING,
      listName: STRING,
      paidListings: INTEGER,
      product: {
        type: 'array',
        required: false,
        items: PRODUCT
      },
      reasonNoCoverage: STRING,
      sponsoredListings: INTEGER,
      standardListings: INTEGER
    },
    ProductRemoved: {
      product: PRODUCT
    },
    ProductSearched: {
      field: FIELD,
      listId: STRING,
      query: STRING
    },
    ProductViewed: {
      listId: STRING,
      product: PRODUCT,
      viewCorrelationId: STRING
    }
  };

  /**
   * Supported Cohesion web event list
   * @see https://confluence.redventures.net/display/COHSN/Event+Guide
   */

  var eventsList = {
    Alias: {
      type: 'core.Alias.v1',
      event: 'click',
      schema: schemas.Alias
    },
    ApplicationClicked: {
      type: 'redventures.usertracking.v3.ApplicationClicked',
      event: 'click',
      schema: schemas.ApplicationClicked
    },
    CartViewed: {
      type: 'redventures.ecommerce.v1.CartViewed',
      event: 'view',
      schema: schemas.CartViewed
    },
    CheckoutStarted: {
      type: 'redventures.ecommerce.v1.CheckoutStarted',
      event: 'click',
      schema: schemas.CheckoutStarted
    },
    ContentMetadataTracked: {
      type: 'redventures.usertracking.v3.ContentMetadataTracked',
      event: 'view',
      schema: schemas.ContentMetadataTracked
    },
    ElementClicked: {
      type: 'redventures.usertracking.v3.ElementClicked',
      event: 'click',
      schema: schemas.ElementClicked
    },
    ElementSwiped: {
      // TODO: https://stackoverflow.com/a/39545306
      // TODO: https://codepen.io/HunorMarton/post/handling-complex-mouse-and-touch-events-with-rxjs
      type: 'redventures.usertracking.v3.ElementSwiped',
      event: 'swipe',
      schema: schemas.ElementSwiped
    },
    ElementViewed: {
      type: 'redventures.usertracking.v3.ElementViewed',
      event: 'view',
      schema: schemas.ElementViewed
    },
    FieldInputted: {
      type: 'redventures.usertracking.v3.FieldInputted',
      event: 'change',
      schema: schemas.FieldInputted
    },
    FieldSelected: {
      type: 'redventures.usertracking.v3.FieldSelected',
      event: 'change',
      schema: schemas.FieldSelected
    },
    FormBacked: {
      type: 'redventures.usertracking.v3.FormBacked',
      event: 'click',
      schema: schemas.FormBacked
    },
    FormContinued: {
      type: 'redventures.usertracking.v3.FormContinued',
      event: 'click',
      schema: schemas.FormContinued
    },
    FormErrored: {
      type: 'redventures.usertracking.v3.FormErrored',
      event: 'view',
      schema: schemas.FormErrored
    },
    FormExited: {
      type: 'redventures.usertracking.v3.FormExited',
      event: 'click',
      schema: schemas.FormExited
    },
    FormOutcomeReceived: {
      type: 'redventures.usertracking.v3.FormOutcomeReceived',
      event: 'view',
      schema: schemas.FormOutcomeReceived
    },
    FormRestarted: {
      type: 'redventures.usertracking.v3.FormRestarted',
      event: 'click',
      schema: schemas.FormRestarted
    },
    FormStarted: {
      type: 'redventures.usertracking.v3.FormStarted',
      event: 'click',
      schema: schemas.FormStarted
    },
    FormSubmitted: {
      type: 'redventures.usertracking.v3.FormSubmitted',
      event: 'submit',
      schema: schemas.FormSubmitted
    },
    FormViewed: {
      type: 'redventures.usertracking.v3.FormViewed',
      event: 'view',
      schema: schemas.FormViewed
    },
    HopPageViewed: {
      type: 'redventures.creditcards.v1.HopPageViewed',
      event: 'view',
      schema: schemas.HopPageViewed
    },
    ListFiltered: {
      type: 'redventures.usertracking.v3.ListFiltered',
      event: 'click',
      schema: schemas.ListFiltered
    },
    PageErrored: {
      type: 'redventures.usertracking.v3.PageErrored',
      event: 'view',
      schema: schemas.PageErrored
    },
    PageScrolled: {
      type: 'redventures.usertracking.v3.PageScrolled',
      event: 'scroll',
      schema: schemas.PageScrolled
    },
    PageViewed: {
      type: 'redventures.usertracking.v3.PageViewed',
      event: 'view',
      schema: schemas.PageViewed
    },
    PageEngaged: {
      type: 'redventures.usertracking.v3.PageEngaged',
      event: 'click',
      schema: schemas.PageEngaged
    },
    ProductAdded: {
      type: 'redventures.ecommerce.v1.ProductAdded',
      event: 'click',
      schema: schemas.ProductAdded
    },
    ProductClicked: {
      type: 'redventures.ecommerce.v1.ProductClicked',
      event: 'click',
      schema: schemas.ProductClicked
    },
    ProductListFiltered: {
      type: 'redventures.ecommerce.v1.ProductListFiltered',
      event: 'click',
      schema: schemas.ProductListFiltered
    },
    ProductListViewed: {
      type: 'redventures.ecommerce.v1.ProductListViewed',
      event: 'view',
      schema: schemas.ProductListViewed
    },
    ProductRemoved: {
      type: 'redventures.ecommerce.v1.ProductRemoved',
      event: 'click',
      schema: schemas.ProductRemoved
    },
    ProductSearched: {
      type: 'redventures.ecommerce.v1.ProductSearched',
      event: 'click',
      schema: schemas.ProductSearched
    },
    ProductViewed: {
      type: 'redventures.ecommerce.v1.ProductViewed',
      event: 'view',
      schema: schemas.ProductViewed
    }
  };

  /**
   * Check that a value is a string.
   *
   * @param {*} input
   * @return {boolean}
   */
  var isString = (function (input) {
    return typeof input === 'string';
  });

  /**
   * Check if the object has the property.
   *
   * @param {object} obj
   * @param {string} prop
   * @return {boolean}
   */

  var hasOwnProperty = (function (obj, prop) {
    if (!isString(prop)) {
      return false;
    }

    return Object.prototype.hasOwnProperty.call(obj, prop);
  });

  /**
   * Check if an input is an Array.
   *
   * @param {*} input
   * @return {boolean}
   */
  var isArray = (function (input) {
    return Array.isArray(input);
  });

  /**
   * Check if an input is a plain object ({}).
   * @param {*} input
   * @return {boolean}
   */
  var isPlainObject = (function (input) {
    return Object.prototype.toString.call(input) === '[object Object]';
  });

  /**
   * Make sure an input is not empty (based on the type).
   *
   * @param {*} input
   * @return {boolean}
   */

  var isEmpty = (function (input) {
    switch (_typeof(input)) {
      case 'string':
        return input.trim() === '';

      case 'number':
        return parseInt("".concat(input), 10) === 0;

      default:
        if (isArray(input)) {
          return input.length === 0;
        }

        if (isPlainObject(input)) {
          return Object.keys(input).length === 0;
        }

        return input == null;
    }
  });

  function createCommonjsModule(fn, module) {
    return module = { exports: {} }, fn(module, module.exports), module.exports;
  }

  /**
   * Helpers.
   */
  var s = 1000;
  var m = s * 60;
  var h = m * 60;
  var d = h * 24;
  var w = d * 7;
  var y = d * 365.25;
  /**
   * Parse or format the given `val`.
   *
   * Options:
   *
   *  - `long` verbose formatting [false]
   *
   * @param {String|Number} val
   * @param {Object} [options]
   * @throws {Error} throw an error if val is not a non-empty string or a number
   * @return {String|Number}
   * @api public
   */

  var ms = function ms(val, options) {
    options = options || {};

    var type = _typeof(val);

    if (type === 'string' && val.length > 0) {
      return parse(val);
    } else if (type === 'number' && isFinite(val)) {
      return options.long ? fmtLong(val) : fmtShort(val);
    }

    throw new Error('val is not a non-empty string or a valid number. val=' + JSON.stringify(val));
  };
  /**
   * Parse the given `str` and return milliseconds.
   *
   * @param {String} str
   * @return {Number}
   * @api private
   */


  function parse(str) {
    str = String(str);

    if (str.length > 100) {
      return;
    }

    var match = /^(-?(?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|weeks?|w|years?|yrs?|y)?$/i.exec(str);

    if (!match) {
      return;
    }

    var n = parseFloat(match[1]);
    var type = (match[2] || 'ms').toLowerCase();

    switch (type) {
      case 'years':
      case 'year':
      case 'yrs':
      case 'yr':
      case 'y':
        return n * y;

      case 'weeks':
      case 'week':
      case 'w':
        return n * w;

      case 'days':
      case 'day':
      case 'd':
        return n * d;

      case 'hours':
      case 'hour':
      case 'hrs':
      case 'hr':
      case 'h':
        return n * h;

      case 'minutes':
      case 'minute':
      case 'mins':
      case 'min':
      case 'm':
        return n * m;

      case 'seconds':
      case 'second':
      case 'secs':
      case 'sec':
      case 's':
        return n * s;

      case 'milliseconds':
      case 'millisecond':
      case 'msecs':
      case 'msec':
      case 'ms':
        return n;

      default:
        return undefined;
    }
  }
  /**
   * Short format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */


  function fmtShort(ms) {
    var msAbs = Math.abs(ms);

    if (msAbs >= d) {
      return Math.round(ms / d) + 'd';
    }

    if (msAbs >= h) {
      return Math.round(ms / h) + 'h';
    }

    if (msAbs >= m) {
      return Math.round(ms / m) + 'm';
    }

    if (msAbs >= s) {
      return Math.round(ms / s) + 's';
    }

    return ms + 'ms';
  }
  /**
   * Long format for `ms`.
   *
   * @param {Number} ms
   * @return {String}
   * @api private
   */


  function fmtLong(ms) {
    var msAbs = Math.abs(ms);

    if (msAbs >= d) {
      return plural(ms, msAbs, d, 'day');
    }

    if (msAbs >= h) {
      return plural(ms, msAbs, h, 'hour');
    }

    if (msAbs >= m) {
      return plural(ms, msAbs, m, 'minute');
    }

    if (msAbs >= s) {
      return plural(ms, msAbs, s, 'second');
    }

    return ms + ' ms';
  }
  /**
   * Pluralization helper.
   */


  function plural(ms, msAbs, n, name) {
    var isPlural = msAbs >= n * 1.5;
    return Math.round(ms / n) + ' ' + name + (isPlural ? 's' : '');
  }

  /**
   * This is the common logic for both the Node.js and web browser
   * implementations of `debug()`.
   */

  function setup(env) {
    createDebug.debug = createDebug;
    createDebug.default = createDebug;
    createDebug.coerce = coerce;
    createDebug.disable = disable;
    createDebug.enable = enable;
    createDebug.enabled = enabled;
    createDebug.humanize = ms;
    Object.keys(env).forEach(function (key) {
      createDebug[key] = env[key];
    });
    /**
     * Active `debug` instances.
     */

    createDebug.instances = [];
    /**
     * The currently active debug mode names, and names to skip.
     */

    createDebug.names = [];
    createDebug.skips = [];
    /**
     * Map of special "%n" handling functions, for the debug "format" argument.
     *
     * Valid key names are a single, lower or upper-case letter, i.e. "n" and "N".
     */

    createDebug.formatters = {};
    /**
     * Selects a color for a debug namespace
     * @param {String} namespace The namespace string for the for the debug instance to be colored
     * @return {Number|String} An ANSI color code for the given namespace
     * @api private
     */

    function selectColor(namespace) {
      var hash = 0;

      for (var i = 0; i < namespace.length; i++) {
        hash = (hash << 5) - hash + namespace.charCodeAt(i);
        hash |= 0; // Convert to 32bit integer
      }

      return createDebug.colors[Math.abs(hash) % createDebug.colors.length];
    }

    createDebug.selectColor = selectColor;
    /**
     * Create a debugger with the given `namespace`.
     *
     * @param {String} namespace
     * @return {Function}
     * @api public
     */

    function createDebug(namespace) {
      var prevTime;

      function debug() {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        // Disabled?
        if (!debug.enabled) {
          return;
        }

        var self = debug; // Set `diff` timestamp

        var curr = Number(new Date());
        var ms = curr - (prevTime || curr);
        self.diff = ms;
        self.prev = prevTime;
        self.curr = curr;
        prevTime = curr;
        args[0] = createDebug.coerce(args[0]);

        if (typeof args[0] !== 'string') {
          // Anything else let's inspect with %O
          args.unshift('%O');
        } // Apply any `formatters` transformations


        var index = 0;
        args[0] = args[0].replace(/%([a-zA-Z%])/g, function (match, format) {
          // If we encounter an escaped % then don't increase the array index
          if (match === '%%') {
            return match;
          }

          index++;
          var formatter = createDebug.formatters[format];

          if (typeof formatter === 'function') {
            var val = args[index];
            match = formatter.call(self, val); // Now we need to remove `args[index]` since it's inlined in the `format`

            args.splice(index, 1);
            index--;
          }

          return match;
        }); // Apply env-specific formatting (colors, etc.)

        createDebug.formatArgs.call(self, args);
        var logFn = self.log || createDebug.log;
        logFn.apply(self, args);
      }

      debug.namespace = namespace;
      debug.enabled = createDebug.enabled(namespace);
      debug.useColors = createDebug.useColors();
      debug.color = selectColor(namespace);
      debug.destroy = destroy;
      debug.extend = extend; // Debug.formatArgs = formatArgs;
      // debug.rawLog = rawLog;
      // env-specific initialization logic for debug instances

      if (typeof createDebug.init === 'function') {
        createDebug.init(debug);
      }

      createDebug.instances.push(debug);
      return debug;
    }

    function destroy() {
      var index = createDebug.instances.indexOf(this);

      if (index !== -1) {
        createDebug.instances.splice(index, 1);
        return true;
      }

      return false;
    }

    function extend(namespace, delimiter) {
      var newDebug = createDebug(this.namespace + (typeof delimiter === 'undefined' ? ':' : delimiter) + namespace);
      newDebug.log = this.log;
      return newDebug;
    }
    /**
     * Enables a debug mode by namespaces. This can include modes
     * separated by a colon and wildcards.
     *
     * @param {String} namespaces
     * @api public
     */


    function enable(namespaces) {
      createDebug.save(namespaces);
      createDebug.names = [];
      createDebug.skips = [];
      var i;
      var split = (typeof namespaces === 'string' ? namespaces : '').split(/[\s,]+/);
      var len = split.length;

      for (i = 0; i < len; i++) {
        if (!split[i]) {
          // ignore empty strings
          continue;
        }

        namespaces = split[i].replace(/\*/g, '.*?');

        if (namespaces[0] === '-') {
          createDebug.skips.push(new RegExp('^' + namespaces.substr(1) + '$'));
        } else {
          createDebug.names.push(new RegExp('^' + namespaces + '$'));
        }
      }

      for (i = 0; i < createDebug.instances.length; i++) {
        var instance = createDebug.instances[i];
        instance.enabled = createDebug.enabled(instance.namespace);
      }
    }
    /**
     * Disable debug output.
     *
     * @return {String} namespaces
     * @api public
     */


    function disable() {
      var namespaces = [].concat(_toConsumableArray(createDebug.names.map(toNamespace)), _toConsumableArray(createDebug.skips.map(toNamespace).map(function (namespace) {
        return '-' + namespace;
      }))).join(',');
      createDebug.enable('');
      return namespaces;
    }
    /**
     * Returns true if the given mode name is enabled, false otherwise.
     *
     * @param {String} name
     * @return {Boolean}
     * @api public
     */


    function enabled(name) {
      if (name[name.length - 1] === '*') {
        return true;
      }

      var i;
      var len;

      for (i = 0, len = createDebug.skips.length; i < len; i++) {
        if (createDebug.skips[i].test(name)) {
          return false;
        }
      }

      for (i = 0, len = createDebug.names.length; i < len; i++) {
        if (createDebug.names[i].test(name)) {
          return true;
        }
      }

      return false;
    }
    /**
     * Convert regexp to namespace
     *
     * @param {RegExp} regxep
     * @return {String} namespace
     * @api private
     */


    function toNamespace(regexp) {
      return regexp.toString().substring(2, regexp.toString().length - 2).replace(/\.\*\?$/, '*');
    }
    /**
     * Coerce `val`.
     *
     * @param {Mixed} val
     * @return {Mixed}
     * @api private
     */


    function coerce(val) {
      if (val instanceof Error) {
        return val.stack || val.message;
      }

      return val;
    }

    createDebug.enable(createDebug.load());
    return createDebug;
  }

  var common = setup;

  var browser = createCommonjsModule(function (module, exports) {
    /* eslint-env browser */

    /**
     * This is the web browser implementation of `debug()`.
     */
    exports.log = log;
    exports.formatArgs = formatArgs;
    exports.save = save;
    exports.load = load;
    exports.useColors = useColors;
    exports.storage = localstorage();
    /**
     * Colors.
     */

    exports.colors = ['#0000CC', '#0000FF', '#0033CC', '#0033FF', '#0066CC', '#0066FF', '#0099CC', '#0099FF', '#00CC00', '#00CC33', '#00CC66', '#00CC99', '#00CCCC', '#00CCFF', '#3300CC', '#3300FF', '#3333CC', '#3333FF', '#3366CC', '#3366FF', '#3399CC', '#3399FF', '#33CC00', '#33CC33', '#33CC66', '#33CC99', '#33CCCC', '#33CCFF', '#6600CC', '#6600FF', '#6633CC', '#6633FF', '#66CC00', '#66CC33', '#9900CC', '#9900FF', '#9933CC', '#9933FF', '#99CC00', '#99CC33', '#CC0000', '#CC0033', '#CC0066', '#CC0099', '#CC00CC', '#CC00FF', '#CC3300', '#CC3333', '#CC3366', '#CC3399', '#CC33CC', '#CC33FF', '#CC6600', '#CC6633', '#CC9900', '#CC9933', '#CCCC00', '#CCCC33', '#FF0000', '#FF0033', '#FF0066', '#FF0099', '#FF00CC', '#FF00FF', '#FF3300', '#FF3333', '#FF3366', '#FF3399', '#FF33CC', '#FF33FF', '#FF6600', '#FF6633', '#FF9900', '#FF9933', '#FFCC00', '#FFCC33'];
    /**
     * Currently only WebKit-based Web Inspectors, Firefox >= v31,
     * and the Firebug extension (any Firefox version) are known
     * to support "%c" CSS customizations.
     *
     * TODO: add a `localStorage` variable to explicitly enable/disable colors
     */
    // eslint-disable-next-line complexity

    function useColors() {
      // NB: In an Electron preload script, document will be defined but not fully
      // initialized. Since we know we're in Chrome, we'll just detect this case
      // explicitly
      if (typeof window !== 'undefined' && window.process && (window.process.type === 'renderer' || window.process.__nwjs)) {
        return true;
      } // Internet Explorer and Edge do not support colors.


      if (typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/(edge|trident)\/(\d+)/)) {
        return false;
      } // Is webkit? http://stackoverflow.com/a/16459606/376773
      // document is undefined in react-native: https://github.com/facebook/react-native/pull/1632


      return typeof document !== 'undefined' && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || // Is firebug? http://stackoverflow.com/a/398120/376773
        typeof window !== 'undefined' && window.console && (window.console.firebug || window.console.exception && window.console.table) || // Is firefox >= v31?
        // https://developer.mozilla.org/en-US/docs/Tools/Web_Console#Styling_messages
        typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || // Double check webkit in userAgent just in case we are in a worker
        typeof navigator !== 'undefined' && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
    }
    /**
     * Colorize log arguments if enabled.
     *
     * @api public
     */


    function formatArgs(args) {
      args[0] = (this.useColors ? '%c' : '') + this.namespace + (this.useColors ? ' %c' : ' ') + args[0] + (this.useColors ? '%c ' : ' ') + '+' + module.exports.humanize(this.diff);

      if (!this.useColors) {
        return;
      }

      var c = 'color: ' + this.color;
      args.splice(1, 0, c, 'color: inherit'); // The final "%c" is somewhat tricky, because there could be other
      // arguments passed either before or after the %c, so we need to
      // figure out the correct index to insert the CSS into

      var index = 0;
      var lastC = 0;
      args[0].replace(/%[a-zA-Z%]/g, function (match) {
        if (match === '%%') {
          return;
        }

        index++;

        if (match === '%c') {
          // We only are interested in the *last* %c
          // (the user may have provided their own)
          lastC = index;
        }
      });
      args.splice(lastC, 0, c);
    }
    /**
     * Invokes `console.log()` when available.
     * No-op when `console.log` is not a "function".
     *
     * @api public
     */


    function log() {
      var _console;

      // This hackery is required for IE8/9, where
      // the `console.log` function doesn't have 'apply'
      return (typeof console === "undefined" ? "undefined" : _typeof(console)) === 'object' && console.log && (_console = console).log.apply(_console, arguments);
    }
    /**
     * Save `namespaces`.
     *
     * @param {String} namespaces
     * @api private
     */


    function save(namespaces) {
      try {
        if (namespaces) {
          exports.storage.setItem('debug', namespaces);
        } else {
          exports.storage.removeItem('debug');
        }
      } catch (error) {// Swallow
        // XXX (@Qix-) should we be logging these?
      }
    }
    /**
     * Load `namespaces`.
     *
     * @return {String} returns the previously persisted debug modes
     * @api private
     */


    function load() {
      var r;

      try {
        r = exports.storage.getItem('debug');
      } catch (error) {} // Swallow
      // XXX (@Qix-) should we be logging these?
      // If debug isn't set in LS, and we're in Electron, try to load $DEBUG


      if (!r && typeof process !== 'undefined' && 'env' in process) {
        r = process.env.DEBUG;
      }

      return r;
    }
    /**
     * Localstorage attempts to return the localstorage.
     *
     * This is necessary because safari throws
     * when a user disables cookies/localstorage
     * and you attempt to access it.
     *
     * @return {LocalStorage}
     * @api private
     */


    function localstorage() {
      try {
        // TVMLKit (Apple TV JS Runtime) does not have a window object, just localStorage in the global context
        // The Browser also has localStorage in the global context.
        return localStorage;
      } catch (error) {// Swallow
        // XXX (@Qix-) should we be logging these?
      }
    }

    module.exports = common(exports);
    var formatters = module.exports.formatters;
    /**
     * Map %j to `JSON.stringify()`, since no Web Inspectors do that by default.
     */

    formatters.j = function (v) {
      try {
        return JSON.stringify(v);
      } catch (error) {
        return '[UnexpectedJSONParseError]: ' + error.message;
      }
    };
  });
  var browser_1 = browser.log;
  var browser_2 = browser.formatArgs;
  var browser_3 = browser.save;
  var browser_4 = browser.load;
  var browser_5 = browser.useColors;
  var browser_6 = browser.storage;
  var browser_7 = browser.colors;

  /**
   * Check if an input is undefined.
   *
   * @param {*} input
   * @return {boolean}
   */
  var isUndefined = (function (input) {
    return typeof input === 'undefined';
  });

  /**
   * Deep merge two or more objects together.
   * Unlike lodash/merge, it always creates a new object (non-destructive).
   * @see https://vanillajstoolkit.com/helpers/deepmerge/
   *
   * @param   {object}   objects  The objects to merge together
   * @returns {object}            Merged values of defaults and options
   */

  function deepMerge() {
    // Setup merged object
    var newObj = {}; // Merge the object into the newObj object

    function merge(obj) {
      if (isEmpty(obj) || isUndefined(obj)) {
        return;
      }

      Object.keys(obj).forEach(function (prop) {
        if (Object.prototype.hasOwnProperty.call(obj, prop)) {
          // If property is an object, merge properties
          if (isPlainObject(obj[prop])) {
            newObj[prop] = deepMerge(newObj[prop], obj[prop]);
          } else {
            newObj[prop] = obj[prop];
          }
        }
      });
    } // Loop through each object and conduct a merge


    for (var _len = arguments.length, objects = new Array(_len), _key = 0; _key < _len; _key++) {
      objects[_key] = arguments[_key];
    }

    objects.forEach(merge);
    return newObj;
  }

  /**
   * Escape special characters in the given string of text.
   *
   * @param  {string} string The string to escape for inserting into HTML
   * @return {string}
   * @public
   */
  var escape = (function (string) {
    var str = "".concat(string);
    var match = /["'&<>]/.exec(str);

    if (!match) {
      return str;
    }

    var escape;
    var html = '';
    var index = match.index;
    var lastIndex = 0;

    for (index; index < str.length; index += 1) {
      switch (str.charCodeAt(index)) {
        case 34:
          // "
          escape = '&quot;';
          break;

        case 38:
          // &
          escape = '&amp;';
          break;

        case 39:
          // '
          escape = '&#39;';
          break;

        case 60:
          // <
          escape = '&lt;';
          break;

        case 62:
          // >
          escape = '&gt;';
          break;

        default:
          // eslint-disable-next-line no-continue
          continue;
      }

      if (lastIndex !== index) {
        html += str.substring(lastIndex, index);
      }

      lastIndex = index + 1;
      html += escape;
    }

    return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
  });

  /**
   * The the value of a query string parameter
   * @param {string} variable
   * @return {string|boolean}
   */

  var getQueryString = (function (variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');

    for (var i = 0; i < vars.length; i += 1) {
      var pair = vars[i].split('=');

      if (pair[0] === variable) {
        return escape(decodeURIComponent(pair[1]));
      }
    }

    return false;
  });

  var localStorage$1 = window.sessionStorage;
  var getItem = function getItem(name) {
    try {
      var serializedState = localStorage$1.getItem(name);

      if (serializedState === null) {
        return undefined;
      }

      return JSON.parse(serializedState);
    } catch (err) {
      return undefined;
    }
  };
  var removeItem = function removeItem(name) {
    try {
      localStorage$1.removeItem(name);
    } catch (err) {// Ignore errors
    }
  };
  var setItem = function setItem(name, state) {
    try {
      var serializedState = JSON.stringify(state);
      localStorage$1.setItem(name, serializedState);
    } catch (err) {// Ignore write errors
    }
  };

  var DEBUG = 'beamDebug';
  var qs = getQueryString('beamDebug');
  var debugMode = function debugMode() {
    return getItem(DEBUG);
  };

  if (qs) {
    if (qs.toLowerCase() === 'true' || qs === '1') {
      setItem(DEBUG, true);
    } else if (qs.toLowerCase() === 'false' || qs === '0') {
      removeItem(DEBUG);
    }
  }

  if (debugMode()) {
    browser.enable('beam*');
    browser.log = console.log.bind(console); // eslint-disable-line no-console
  } else {
    browser.disable();
  }

  var logger = (function () {
    var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'debug';
    return function () {
      for (var _len = arguments.length, message = new Array(_len), _key = 0; _key < _len; _key++) {
        message[_key] = arguments[_key];
      }

      var output = message.map(function (msg) {
        if (isPlainObject(msg)) {
          return deepMerge(msg);
        }

        return msg;
      });
      return browser("beam:".concat(name)).apply(void 0, _toConsumableArray(output));
    };
  });

  /**
   * Get an object value from a specific path (like Lodash "get").
   *
   * @param  {object}       obj
   * @param  {string|array} path
   * @param  {*}            def
   * @return {*}
   */
  function get (obj, path) {
    var def = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    /**
     * If the path is a string, convert it to an array.
     *
     * @param  {string|array} input
     * @return {array}
     */
    var splitPath = function splitPath(input) {
      // If the path isn't a string, return it
      if (typeof input !== 'string') {
        return input;
      } // Create new array


      var output = []; // Split to an array with dot notation

      input.split('.').forEach(function (item) {
        // Split to an array with bracket notation
        item.split(/\[([^}]+)\]/g).forEach(function (key) {
          // Push to the new array
          if (key.length > 0) {
            output.push(key);
          }
        });
      });
      return output;
    }; // Get the path as an array


    var pathArray = splitPath(path); // Cache the current object

    var current = obj; // For each item in the path, dig into the object

    for (var i = 0; i < pathArray.length; i += 1) {
      // If the item isn't found, return the default (or null)
      if (!current[pathArray[i]]) {
        return def;
      } // Otherwise, update the current  value


      current = current[pathArray[i]];
    }

    return current;
  }

  /**
   * Check if an input is a function.
   *
   * @param {*} input
   * @return {boolean}
   */
  var isFunction = (function (input) {
    return typeof input === 'function';
  });

  var log = logger('utils:callFn');
  /**
   * Call a function by its name
   * @param {String} fn Function name/reference
   * @param {Object} context Context to run function
   * @param {Array} args Arguments
   */

  var callFnByName = function callFnByName(fn) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : window;
    var args = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    if (isUndefined(fn) || !isString(fn)) {
      throw new Error('A function name was not specified');
    }

    var namespaces = fn.split('.');
    var name = namespaces.pop();

    if (namespaces.length > 0) {
      /* eslint-disable no-param-reassign */
      context = get(context, namespaces.join('.'), context);
      /* eslint-enable */
    }

    var newFn = context[name];

    if (!isFunction(newFn)) {
      throw new Error("\"".concat(context, ".").concat(name, "\" is not a function"));
    }

    return newFn.apply(context, args);
  };

  var callFn = (function (fn) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var result = '';

    try {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      if (isFunction(fn)) {
        result = context ? fn.apply(context, args) : fn(args);
      } else if (isString(fn)) {
        result = callFnByName(fn, context, args);
      }
    } catch (err) {
      log('Error', fn, context, err);
      result = '';
    }

    return result;
  });

  function symbolObservablePonyfill(root) {
    var result;
    var _Symbol = root.Symbol;

    if (typeof _Symbol === 'function') {
      if (_Symbol.observable) {
        result = _Symbol.observable;
      } else {
        result = _Symbol('observable');
        _Symbol.observable = result;
      }
    } else {
      result = '@@observable';
    }

    return result;
  }

  /* global window */
  var root;

  if (typeof self !== 'undefined') {
    root = self;
  } else if (typeof window !== 'undefined') {
    root = window;
  } else if (typeof global !== 'undefined') {
    root = global;
  } else if (typeof module !== 'undefined') {
    root = module;
  } else {
    root = Function('return this')();
  }

  var result = symbolObservablePonyfill(root);

  /**
   * These are private action types reserved by Redux.
   * For any unknown actions, you must return the current state.
   * If the current state is undefined, you must return the initial state.
   * Do not reference these action types directly in your code.
   */

  var randomString = function randomString() {
    return Math.random().toString(36).substring(7).split('').join('.');
  };

  var ActionTypes = {
    INIT: "@@redux/INIT" + randomString(),
    REPLACE: "@@redux/REPLACE" + randomString(),
    PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
      return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
    }
  };
  /**
   * @param {any} obj The object to inspect.
   * @returns {boolean} True if the argument appears to be a plain object.
   */

  function isPlainObject$1(obj) {
    if (_typeof(obj) !== 'object' || obj === null) return false;
    var proto = obj;

    while (Object.getPrototypeOf(proto) !== null) {
      proto = Object.getPrototypeOf(proto);
    }

    return Object.getPrototypeOf(obj) === proto;
  }
  /**
   * Creates a Redux store that holds the state tree.
   * The only way to change the data in the store is to call `dispatch()` on it.
   *
   * There should only be a single store in your app. To specify how different
   * parts of the state tree respond to actions, you may combine several reducers
   * into a single reducer function by using `combineReducers`.
   *
   * @param {Function} reducer A function that returns the next state tree, given
   * the current state tree and the action to handle.
   *
   * @param {any} [preloadedState] The initial state. You may optionally specify it
   * to hydrate the state from the server in universal apps, or to restore a
   * previously serialized user session.
   * If you use `combineReducers` to produce the root reducer function, this must be
   * an object with the same shape as `combineReducers` keys.
   *
   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
   * to enhance the store with third-party capabilities such as middleware,
   * time travel, persistence, etc. The only store enhancer that ships with Redux
   * is `applyMiddleware()`.
   *
   * @returns {Store} A Redux store that lets you read the state, dispatch actions
   * and subscribe to changes.
   */


  function createStore(reducer, preloadedState, enhancer) {
    var _ref2;

    if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
      throw new Error('It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function.');
    }

    if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
      enhancer = preloadedState;
      preloadedState = undefined;
    }

    if (typeof enhancer !== 'undefined') {
      if (typeof enhancer !== 'function') {
        throw new Error('Expected the enhancer to be a function.');
      }

      return enhancer(createStore)(reducer, preloadedState);
    }

    if (typeof reducer !== 'function') {
      throw new Error('Expected the reducer to be a function.');
    }

    var currentReducer = reducer;
    var currentState = preloadedState;
    var currentListeners = [];
    var nextListeners = currentListeners;
    var isDispatching = false;
    /**
     * This makes a shallow copy of currentListeners so we can use
     * nextListeners as a temporary list while dispatching.
     *
     * This prevents any bugs around consumers calling
     * subscribe/unsubscribe in the middle of a dispatch.
     */

    function ensureCanMutateNextListeners() {
      if (nextListeners === currentListeners) {
        nextListeners = currentListeners.slice();
      }
    }
    /**
     * Reads the state tree managed by the store.
     *
     * @returns {any} The current state tree of your application.
     */


    function getState() {
      if (isDispatching) {
        throw new Error('You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
      }

      return currentState;
    }
    /**
     * Adds a change listener. It will be called any time an action is dispatched,
     * and some part of the state tree may potentially have changed. You may then
     * call `getState()` to read the current state tree inside the callback.
     *
     * You may call `dispatch()` from a change listener, with the following
     * caveats:
     *
     * 1. The subscriptions are snapshotted just before every `dispatch()` call.
     * If you subscribe or unsubscribe while the listeners are being invoked, this
     * will not have any effect on the `dispatch()` that is currently in progress.
     * However, the next `dispatch()` call, whether nested or not, will use a more
     * recent snapshot of the subscription list.
     *
     * 2. The listener should not expect to see all state changes, as the state
     * might have been updated multiple times during a nested `dispatch()` before
     * the listener is called. It is, however, guaranteed that all subscribers
     * registered before the `dispatch()` started will be called with the latest
     * state by the time it exits.
     *
     * @param {Function} listener A callback to be invoked on every dispatch.
     * @returns {Function} A function to remove this change listener.
     */


    function subscribe(listener) {
      if (typeof listener !== 'function') {
        throw new Error('Expected the listener to be a function.');
      }

      if (isDispatching) {
        throw new Error('You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
      }

      var isSubscribed = true;
      ensureCanMutateNextListeners();
      nextListeners.push(listener);
      return function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        if (isDispatching) {
          throw new Error('You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api-reference/store#subscribelistener for more details.');
        }

        isSubscribed = false;
        ensureCanMutateNextListeners();
        var index = nextListeners.indexOf(listener);
        nextListeners.splice(index, 1);
        currentListeners = null;
      };
    }
    /**
     * Dispatches an action. It is the only way to trigger a state change.
     *
     * The `reducer` function, used to create the store, will be called with the
     * current state tree and the given `action`. Its return value will
     * be considered the **next** state of the tree, and the change listeners
     * will be notified.
     *
     * The base implementation only supports plain object actions. If you want to
     * dispatch a Promise, an Observable, a thunk, or something else, you need to
     * wrap your store creating function into the corresponding middleware. For
     * example, see the documentation for the `redux-thunk` package. Even the
     * middleware will eventually dispatch plain object actions using this method.
     *
     * @param {Object} action A plain object representing “what changed”. It is
     * a good idea to keep actions serializable so you can record and replay user
     * sessions, or use the time travelling `redux-devtools`. An action must have
     * a `type` property which may not be `undefined`. It is a good idea to use
     * string constants for action types.
     *
     * @returns {Object} For convenience, the same action object you dispatched.
     *
     * Note that, if you use a custom middleware, it may wrap `dispatch()` to
     * return something else (for example, a Promise you can await).
     */


    function dispatch(action) {
      if (!isPlainObject$1(action)) {
        throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
      }

      if (typeof action.type === 'undefined') {
        throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
      }

      if (isDispatching) {
        throw new Error('Reducers may not dispatch actions.');
      }

      try {
        isDispatching = true;
        currentState = currentReducer(currentState, action);
      } finally {
        isDispatching = false;
      }

      var listeners = currentListeners = nextListeners;

      for (var i = 0; i < listeners.length; i++) {
        var listener = listeners[i];
        listener();
      }

      return action;
    }
    /**
     * Replaces the reducer currently used by the store to calculate the state.
     *
     * You might need this if your app implements code splitting and you want to
     * load some of the reducers dynamically. You might also need this if you
     * implement a hot reloading mechanism for Redux.
     *
     * @param {Function} nextReducer The reducer for the store to use instead.
     * @returns {void}
     */


    function replaceReducer(nextReducer) {
      if (typeof nextReducer !== 'function') {
        throw new Error('Expected the nextReducer to be a function.');
      }

      currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
      // Any reducers that existed in both the new and old rootReducer
      // will receive the previous state. This effectively populates
      // the new state tree with any relevant data from the old one.

      dispatch({
        type: ActionTypes.REPLACE
      });
    }
    /**
     * Interoperability point for observable/reactive libraries.
     * @returns {observable} A minimal observable of state changes.
     * For more information, see the observable proposal:
     * https://github.com/tc39/proposal-observable
     */


    function observable() {
      var _ref;

      var outerSubscribe = subscribe;
      return _ref = {
        /**
         * The minimal observable subscription method.
         * @param {Object} observer Any object that can be used as an observer.
         * The observer object should have a `next` method.
         * @returns {subscription} An object with an `unsubscribe` method that can
         * be used to unsubscribe the observable from the store, and prevent further
         * emission of values from the observable.
         */
        subscribe: function subscribe(observer) {
          if (_typeof(observer) !== 'object' || observer === null) {
            throw new TypeError('Expected the observer to be an object.');
          }

          function observeState() {
            if (observer.next) {
              observer.next(getState());
            }
          }

          observeState();
          var unsubscribe = outerSubscribe(observeState);
          return {
            unsubscribe: unsubscribe
          };
        }
      }, _ref[result] = function () {
        return this;
      }, _ref;
    } // When a store is created, an "INIT" action is dispatched so that every
    // reducer returns their initial state. This effectively populates
    // the initial state tree.


    dispatch({
      type: ActionTypes.INIT
    });
    return _ref2 = {
      dispatch: dispatch,
      subscribe: subscribe,
      getState: getState,
      replaceReducer: replaceReducer
    }, _ref2[result] = observable, _ref2;
  }

  var ADD_OBSERVER = 'ADD_OBSERVER';
  var ADD_VARS = 'ADD_VARS';
  var DEQUEUE = 'DEQUEUE';
  var ENQUEUE = 'ENQUEUE';
  var INCREMENT_UID = 'INCREMENT_UID';
  var INITIALIZE = 'INITIALIZE';
  var MAP_DATA = 'MAP_DATA';
  var REMOVE_EVENT = 'REMOVE_EVENT';
  var SCRIPT_PATH = 'SCRIPT_PATH';
  var SOURCE_CACHE = 'SOURCE_CACHE';

  var initialState = {
    data: {},
    initialized: false,
    observers: {},
    queue: [],
    scriptPath: './',
    sourceCache: {},
    uid: 1,
    vars: {}
  };

  function cache(state, action) {
    /* eslint-disable no-param-reassign */
    switch (action.type) {
      case ADD_OBSERVER:
        if (action.name && action.observer) {
          state.observers[action.name] = action.observer;
        }

        return state;

      case ADD_VARS:
        if (isPlainObject(action.vars)) {
          state.vars = deepMerge(state.vars, action.vars);
        }

        return state;

      case DEQUEUE:
        if (state.queue.length > 0) {
          state.queue.shift();
        }

        return state;

      case ENQUEUE:
        if (isPlainObject(action.source)) {
          state.queue.push(action.source);
        }

        return state;

      case INCREMENT_UID:
        state.uid += 1;
        return state;

      case INITIALIZE:
        state.initialized = true;
        return state;

      case MAP_DATA:
        if (!hasOwnProperty(state.data, action.uid) && isPlainObject(action.data)) {
          state.data[action.uid] = action.data;
        }

        return state;

      case REMOVE_EVENT:
        if (action.uid && action.uid in state.data) {
          delete state.data[action.uid];
        }

        return state;

      case SOURCE_CACHE:
        if (isPlainObject(action.source)) {
          state.sourceCache = deepMerge(state.sourceCache, action.source);
        }

        return state;

      case SCRIPT_PATH:
        if (isString(action.path)) {
          // Clean it up a bit to prevent haxx
          var paths = action.path.split('/').map(function (part) {
            return escape(part.replace(/https?:|\?/ig, ''));
          }).filter(function (part) {
            return part != null && part.length > 0;
          });
          state.scriptPath = paths.join('/');
        }

        return state;

      default:
        return state;
    }
    /* eslint-enable no-param-reassign */

  }

  var store = createStore(cache, initialState, // eslint-disable-next-line no-underscore-dangle
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__());

  /* eslint-disable no-bitwise, no-mixed-operators */
  // Generate uuidv4 ID number
  // https://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
  var uuid = (function () {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (char) {
      var rand = Math.random() * 16 | 0;
      var val = char === 'x' ? rand : rand & 0x3 | 0x8;
      return val.toString(16);
    });
  });

  var log$1 = logger('wildcard');
  /**
   * Traverse up the element stack until we find an input's form parent.
   *
   * @param  {HTMLElement} element   DOM element
   * @return {HTMLElement|HTMLFormElement}
   */

  var findForm = function findForm(element) {
    var form = element.closest('form');
    return form || element;
  };
  /**
   * Convert wildcard strings into 'real' values.
   *
   * TODO: support 'closest' and 'child' ?
   * TODO: support short-circuit? `||` ?
   *
   * @param  {string} input
   * @param  {HTMLElement|HTMLFormElement|HTMLInputElement} el
   * @return {string|number|boolean}
   */


  var wildcard = (function (input) {
    var el = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

    // Bail early if not a string.
    if (!isString(input)) {
      return input;
    } // Set the default output.


    var output = '';

    try {
      if (input.indexOf('data.') === 0) {
        output = el.dataset[input.replace('data.', '').trim()];
      } else if (input.indexOf('var.') === 0) {
        var _store$getState = store.getState(),
          vars = _store$getState.vars;

        var variable = input.replace('var.', '').trim();

        if (variable && variable in vars) {
          output = vars[variable];
        } else {
          log$1("Unknown variable requested: \"".concat(input, "\""));
        }
      } else if (input.indexOf('qs.') === 0) {
        output = getQueryString(input.replace('qs.', '').trim());
      } else if (input.indexOf('fn.') === 0) {
        output = callFn(input.replace('fn.', '').trim());
      } else {
        // Other supported wildcards
        switch (input) {
          case 'uuid':
          case 'this.uuid':
            output = uuid();
            break;

          case 'page.href':
            output = window.location.href;
            break;

          case 'page.referrer':
            output = document.referrer ? document.referrer : 'direct entry';
            break;

          case 'page.title':
            output = document.title;
            break;

          case 'form.id':
            output = findForm(el).getAttribute('id');
            break;

          case 'form.name':
            output = findForm(el).getAttribute('name');
            break;

          case 'this.href':
            output = el.getAttribute('href');
            break;

          case 'this.innerText':
            output = el.innerText;
            break;

          case 'this.rel':
            output = el.getAttribute('rel');
            break;

          case 'this.title':
            output = el.getAttribute('title');
            break;

          case 'this.alt':
            output = el.getAttribute('alt');
            break;

          case 'this.id':
            output = el.getAttribute('id');
            break;

          case 'this.name':
            output = el.getAttribute('name');
            break;

          case 'this.type':
            output = el.getAttribute('type'); // If `output` is a user-editable input field, set type as 'enum'

            if (['text', 'email', 'tel', 'textarea'].indexOf(output) !== -1) {
              output = 'enum';
            }

            break;

          case 'this.value':
            output = el.value;
            break;

          case 'this.placeholder':
            output = el.getAttribute('placeholder');
            break;

          default:
            output = input;
        }
      }
    } catch (err) {
      log$1('Error', input, el);
      output = '';
    } // Sanity check


    if (!output) {
      output = '';
    }

    return output;
  });

  /**
   * Strip out special characters like ®, ℠, ™, etc.
   * More accurate: strip out any not contained in the ASCII character set (0-127, i.e. 0x0 to 0x7F)
   *
   * @param {string|number|boolean} input
   * @return {string|number|boolean}
   */

  var strip = function strip(input) {
    return (
      /* eslint-disable no-control-regex */
      typeof input === 'string' ? input.replace(/[^\x00-\x7F]+/ig, '').replace(/(\r\n|\n|\r)/gm, ' ').replace(/\s+/g, ' ').trim() : input
      /* eslint-enable */

    );
  };
  /**
   * Normalize output.
   *
   * @param {String|Number|Boolean|Function|Object|Array} input
   * @param {Document|HTMLElement|HTMLFormElement|HTMLInputElement} context
   * @return {String|Number|Boolean|Function|Object|Array}
   */


  var normalize = function normalize(input) {
    var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document;

    switch (_typeof(input)) {
      case 'string':
        return strip(wildcard(input, context));

      case 'function':
        return callFn(input, context);

      default:
        return strip(input);
    }
  };

  /**
   * Convert input to specific type.
   *
   * @param {string|boolean|number} input
   * @param {string} type
   * @return {string|boolean|number}
   */
  var typeCast = (function (input, type) {
    switch (type) {
      case 'string':
        return "".concat(input).trim();

      case 'number':
        return Number(input) || 0;

      case 'integer':
        return parseInt("".concat(input).trim(), 10) || 0;

      case 'boolean':
        return !!input;

      default:
        return input;
    }
  });

  /**
   * Curried function to compose data.
   *
   * @param {object} data
   * @param {Document|HTMLElement|HTMLFormElement|HTMLInputElement} context
   * @return {function(object, array): object}
   */

  var composer = function composer(data, context) {
    return function (state, _ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        props = _ref2[1];

      /* eslint-disable no-param-reassign */
      if (key in data) {
        // Get a reference to the current data value.
        var input = data[key]; // Also grab some props

        var required = props.required,
          type = props.type; // Cast the primitives to their respective types.

        if (['string', 'number', 'integer', 'boolean'].includes(type)) {
          // Normalize the input.
          var value = normalize(input, context); // Don't return empty values for non-required properties.

          if (!isEmpty(value) || required) {
            state[key] = typeCast(value, type);
          }
        } else {
          // Create the reducer.
          var composed = composer(input, context); // Check the prop type.

          if (type === 'object') {
            state[key] = Object.entries(props.properties).reduce(composed, {});
          } else if (type === 'array') {
            state[key] = props.items.reduce(composed, []);
          } else if (type === 'enum') {
            // TODO: confirm item is one of the specified enums...
            state[key] = props.items.reduce(composed, []);
          }
        }
      }
      /* eslint-enable no-param-reassign */


      return state;
    };
  };
  /**
   * Make sure data is in the correct format.
   *
   * @param {object} subject
   * @param {object} subject.data
   * @param {string} subject.event
   * @param {boolean} subject.interpolate
   * @param {Document|HTMLElement|HTMLFormElement|HTMLInputElement} subject.context
   * @return {object}
   */


  var composeData = (function (_ref3) {
    var context = _ref3.context,
      data = _ref3.data,
      event = _ref3.event,
      interpolate = _ref3.interpolate;

    // If interpolation is desired and this event is a supported event...
    if (hasOwnProperty(eventsList, event) && interpolate) {
      // Get the type and schema from the event.
      var _events$event = eventsList[event],
        type = _events$event.type,
        schema = _events$event.schema; // Create the reducer.

      var composed = composer(data, context); // Loop through the schema to compose the new data object.

      return Object.entries(schema).reduce(composed, {
        '@type': type
      });
    } // Otherwise just return the original data


    return data;
  });

  /**
   * Copy a JSON object.
   *
   * @param {object} data
   * @returns {object}
   */
  var copy = (function (data) {
    return JSON.parse(JSON.stringify(data));
  });

  /**
   * Send payload to Validate endpoint.
   *
   * @param {object} payload
   */

  var validate = (function (payload) {
    var _window$_Cohesion = window._Cohesion,
      anonymousId = _window$_Cohesion.anonymousId,
      writeKey = _window$_Cohesion.writeKey; // eslint-disable-line

    var _window$_Tagular = window._Tagular,
      apiKey = _window$_Tagular.config.apiKey,
      webContext = _window$_Tagular.webContext; // eslint-disable-line

    var headers = new Headers();
    headers.set('Authorization', "Basic ".concat(window.btoa(writeKey), ":"));
    var event = payload['@type'];
    var properties = deepMerge(payload);
    delete properties['@type'];

    if (event.indexOf('.Alias') === -1) {
      properties.webContext = webContext;
    }

    var request = new XMLHttpRequest();
    request.open('POST', 'https://make.cohesionapps.com/v1/validate', true);
    request.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
    request.setRequestHeader('Authorization', "Basic ".concat(window.btoa("".concat(writeKey, ":"))));
    request.send(JSON.stringify({
      anonymousId: anonymousId,
      messageId: uuid(),
      event: event,
      properties: properties,
      sentAt: new Date().toISOString(),
      writeKey: apiKey
    }));
  });

  var log$2 = logger('track');
  /**
   * Get the schema type short name.
   * @param {string} type
   * @return {string}
   */

  var getSchemaType = function getSchemaType(type) {
    return type.split('.').pop();
  };
  /**
   * Default subject object.
   *
   * @type {{data: null, context: Document, interpolate: boolean, event: null}}
   */


  var subjectDefaults = {
    context: document,
    data: null,
    event: null,
    interpolate: true
  };
  /**
   * Subject reducer.
   *
   * @param {*[]} parameters
   * @return {*}
   */

  var subjectReducer = function subjectReducer(parameters) {
    return parameters.reduce(function (state, param) {
      /* eslint-disable no-param-reassign */
      if (isString(param)) {
        state.event = param;
      } else if (isPlainObject(param)) {
        state.data = param; // If the event is still null, go ahead and set it
        // based on the '@type' property of the data..

        if (state.event == null) {
          state.event = getSchemaType(param['@type']);
        }
      } else if (param instanceof Element) {
        state.context = param;
      } else if (typeof param === 'boolean') {
        state.interpolate = param;
      }
      /* eslint-enable no-param-reassign */


      return state;
    }, subjectDefaults);
  };
  /**
   * Fire the Tagular "beam".
   *
   * @param {*} args
   */


  var track = (function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    // Loop over any optional parameters and set accordingly.
    var subject = subjectReducer(args);

    if (!subject.data || !subject.event) {
      log$2('Error: Beam was not sent! Subject is invalid.', {
        subject: subject
      });
      return;
    } // Compose the payload.


    var payload = composeData(subject); // Remove "bad" properties from options if ProductViewed event
    // since ProductClicked may have them defined (and they might
    // get used by ProductViewed if auto-bind option is true).

    if (subject.event.indexOf('ProductViewed') !== -1) {
      if (hasOwnProperty(payload, 'actionOutcome')) {
        delete payload.actionOutcome;
      }

      if (hasOwnProperty(payload, 'correlationId')) {
        delete payload.correlationId;
      }

      if (hasOwnProperty(payload, 'outboundUrl')) {
        delete payload.outboundUrl;
      }
    }

    try {
      // Send event data to tagular
      if (hasOwnProperty(window, 'tagular')) {
        if (debugMode()) {
          validate(copy(payload));
        } else {
          window.tagular('beam', subject.event, copy(payload));
        }

        log$2("Beam sent: \"".concat(subject.event, "\"!"), {
          subject: subject,
          payload: payload
        });
      } // Automatically send all data to GTM dataLayer
      // FIXME: add support for custom dataLayer name


      if (hasOwnProperty(window, 'dataLayer')) {
        var gtmEvent = deepMerge({
          event: 'beam'
        }, copy(payload));
        window.dataLayer.push(gtmEvent);
        log$2('GTM dataLayer updated: "beam"!', {
          gtmEvent: gtmEvent
        });
      } // TODO: Add custom callback support?

    } catch (error) {
      log$2('Error: Beam was not sent!', {
        subject: subject,
        payload: payload,
        error: error
      });
      console.error(error.message); // eslint-disable-line no-console
    }
  });

  /**
   * Cohesion event name
   * @type {string}
   */
  var BEAM = 'BEAM';
  /**
   * CartViewed event name
   * @type {string}
   */

  var CART_VIEWED = 'CART_VIEWED';
  /**
   * ElementViewed event name
   * @type {string}
   */

  var ELEMENT_VIEWED = 'ELEMENT_VIEWED';
  /**
   * FormViewed event name
   * @type {string}
   */

  var FORM_VIEWED = 'FORM_VIEWED';
  /**
   * ProductViewed event name
   * @type {string}
   */

  var PRODUCT_VIEWED = 'PRODUCT_VIEWED';
  /**
   * ProductListViewed event name
   * @type {string}
   */

  var PRODUCT_LIST_VIEWED = 'PRODUCT_LIST_VIEWED';

  var browserSupport = (function () {
    var polyfills = {
      CustomEvent: window.CustomEvent,
      'Element.prototype.closest': Element.prototype.closest,
      'Element.prototype.matches': Element.prototype.matches,
      fetch: window.fetch,
      IntersectionObserver: window.IntersectionObserver,
      'NodeList.prototype.forEach': NodeList.prototype.forEach,
      'Object.entries': Object.entries,
      Promise: Promise,
      URL: URL
    };
    return Object.keys(polyfills).reduce(function (result, key) {
      var method = polyfills[key];

      if (!isFunction(method)) {
        result.push(key);
      }

      return result;
    }, []);
  });

  /**
   * Beam event (default)
   * @type {CustomEvent}
   */

  var BeamEvent = new CustomEvent(BEAM, {
    bubbles: true,
    cancelable: true
  });
  /**
   * CartViewed event
   * @type {CustomEvent}
   */

  var CartViewed = new CustomEvent(CART_VIEWED, {
    bubbles: true,
    cancelable: true
  });
  /**
   * ElementViewed event
   * @type {CustomEvent}
   */

  var ElementViewed = new CustomEvent(ELEMENT_VIEWED, {
    bubbles: true,
    cancelable: true
  });
  /**
   * FormViewed event
   * @type {CustomEvent}
   */

  var FormViewed = new CustomEvent(FORM_VIEWED, {
    bubbles: true,
    cancelable: true
  });
  /**
   * ProductViewed event
   * @type {CustomEvent}
   */

  var ProductViewed = new CustomEvent(PRODUCT_VIEWED, {
    bubbles: true,
    cancelable: true
  });
  /**
   * ProductListViewed event
   * @type {CustomEvent}
   */

  var ProductListViewed = new CustomEvent(PRODUCT_LIST_VIEWED, {
    bubbles: true,
    cancelable: true
  });

  var customEvents = /*#__PURE__*/Object.freeze({
    __proto__: null,
    BeamEvent: BeamEvent,
    CartViewed: CartViewed,
    ElementViewed: ElementViewed,
    FormViewed: FormViewed,
    ProductViewed: ProductViewed,
    ProductListViewed: ProductListViewed
  });

  var log$3 = logger('clickHandler');
  /* eslint-disable max-len */

  var clickDefaults = {
    addParamsToHref: false,
    // (if ProductClicked) add params to the link value; use `true` to use HREF value, or a {String} for Element.getAttribute
    addProductViewed: false,
    // (if ProductClicked) automatically bind a ProductViewed event
    addViewEvent: false,
    // automatically bind a *Viewed event
    delay: false,
    // delay any action to allow Beam to send before following link
    once: false // only emit event a single time

  };
  /* eslint-enable */

  /**
   * Handle click events.
   *
   * @param {Event} event
   * @param {object=} settings
   * @param {Element} element
   */

  var clickHandler = (function (event) {
    var settings = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var element = arguments.length > 2 ? arguments[2] : undefined;

    if (!element || !element.hasAttribute('data-tagular-uid')) {
      return;
    } // Create options by merging defaults with config


    var options = deepMerge(clickDefaults, settings); // Make sure we don't interact with disabled elements (or elements intending to be disabled)

    var disabled = element.disabled || element.getAttribute('aria-disabled') === 'true';

    if (disabled) {
      return;
    } // Dispatch the event


    element.dispatchEvent(BeamEvent);

    if (options.once) {
      // TODO: use removeEventListener instead?
      var uid = element.getAttribute('data-tagular-uid');
      log$3("Removing UID=".concat(uid, " because \"once\" option was declared."));
      store.dispatch({
        type: REMOVE_EVENT,
        uid: uid
      });
    }

    var href = element.getAttribute('href');

    if (options.delay && href && href.indexOf('#') !== 0 && element.getAttribute('target') !== '_blank') {
      event.preventDefault();
      log$3('Delaying link follow slightly to allow "beam" to send.');
      setTimeout(function () {
        window.location = element.href;
      }, 100);
    }
  });

  /**
   * No-Op function (placeholder).
   */
  var noop = (function () {});

  var defaults = {
    root: null,
    rootMargin: '0px',
    threshold: [0, 1]
  };
  /**
   * Creates an IntersectionObserver.
   *
   * @param {function} callback
   * @param {object=} options
   * @return {IntersectionObserver}
   */

  var createObserver = (function () {
    var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : noop;
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaults;
    return new IntersectionObserver(callback, options);
  });

  var log$4 = logger('observer');
  /**
   * Is the event a supported "view" event?
   * @param {*} event
   * @return {boolean}
   */

  var isSupportedViewEvent = function isSupportedViewEvent(event) {
    return isString(event) && RegExp('/CartViewed|ElementViewed|FormViewed|ProductListViewed|ProductViewed/', 'i').test(event);
  };
  /* eslint-disable max-len */

  var observerDefaults = {
    root: null,
    // element that is used as the viewport for checking visiblity of the target (null === document's viewport)
    rootMargin: '0px',
    // set of values serves to grow or shrink each side of the root element's bounding box before computing intersections
    threshold: [0.25, 0.5, 0.75, 1] // a single number or an array of numbers which indicate at what percentage of the target's visibility the observer's callback should be executed

  };
  /* eslint-enable */

  /**
   * Observer callback.
   *
   * @param {IntersectionObserverEntry[]} entries
   * @param {IntersectionObserver} observer
   */

  var observerHandler = function observerHandler(entries, observer) {
    entries.forEach(function (entry) {
      var isIntersecting = entry.isIntersecting,
        target = entry.target;

      if (isIntersecting) {
        var name$ = observer.name || '';
        var options$ = observer.options || clickDefaults;

        if (name$.includes('ProductViewed') && options$.addProductViewed === true) {
          target.dispatchEvent(ProductViewed);
        } else if (options$.addViewEvent && isSupportedViewEvent(options$.addViewEvent)) {
          target.dispatchEvent(customEvents[options$.addViewEvent]);
        } else {
          target.dispatchEvent(BeamEvent);
        } // Remove the observer.


        observer.unobserve(target);
      }
    });
  };
  /**
   * Helper to create intersection observers.
   *
   * @param {Element|Node} target
   * @param {string=} name
   * @param {object=} config
   */


  var observer = (function (target) {
    var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'default';
    var config = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    // Try to retrieve an existing observer.
    var _store$getState = store.getState(),
      observers = _store$getState.observers;

    var observer = observers[name]; // If not found, create it.

    if (!observer) {
      log$4("Creating new Intersection Observer: \"".concat(name, "\"")); // Create options by merging defaults with config.

      var options = deepMerge(observerDefaults, config); // Create the observer.

      observer = createObserver(observerHandler, options); // Add some additional properties to the observer for easier identification.

      observer.options = options;
      observer.name = name; // Add the observer to the store for reference.

      store.dispatch({
        type: ADD_OBSERVER,
        name: name,
        observer: observer
      });
    }

    observer.observe(target);
  });

  var originalLink = 'data-tagular-link';
  /**
   * Add Cohesion parameters to HREF value.
   *
   * @param {Element} element
   * @param {string=} attr
   */

  var addParamsToHref = (function (element) {
    var attr = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'href';

    if (!element || !element.hasAttribute('data-tagular-uid')) {
      return;
    }

    var link = element.getAttribute(originalLink);

    if (!link) {
      link = element.getAttribute(attr); // Store the URL for later use so that the cohesion attributes aren't double appended.

      element.setAttribute(originalLink, link);
    } // Abort if no link found or link is anchor


    if (!link || link === '#') {
      return;
    } // Build the Cohesion parameters.


    var _window$_Cohesion = window._Cohesion,
      anonymousId = _window$_Cohesion.anonymousId,
      instanceId = _window$_Cohesion.instanceId,
      sessionId = _window$_Cohesion.sessionId,
      tenantId = _window$_Cohesion.tenantId; // eslint-disable-line

    var cohesionParams = {
      c_anonymous_id: anonymousId,
      c_correlation_id: uuid(),
      c_instance_id: instanceId,
      c_session_id: sessionId,
      c_tenant_id: tenantId
    }; // Construct the URL.

    var url = new URL(link); // Loop over the Cohesion params and append to the search params object in URL.

    Object.entries(cohesionParams).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        value = _ref2[1];

      url.searchParams.append(name, value);
    }); // Update the attribute.

    element.setAttribute(attr, url.href);
  });

  var log$5 = logger('bind');
  /**
   * Get the browser/DOM event to trigger the Beam event.
   *
   * @param {string} type
   * @param {object=} config
   * @return {boolean|string}
   */

  var getBrowserEvent = function getBrowserEvent(type, config) {
    // If a custom configuration is used, check it for the event
    if (config && hasOwnProperty(config, 'event') && isString(config.event)) {
      return config.event.toLowerCase();
    }

    var schema = eventsList[type];

    if (isPlainObject(schema) && hasOwnProperty(schema, 'event')) {
      return schema.event.toLowerCase();
    }

    return false;
  };
  /**
   * Check to see if the element already has a data-tagular-uid attribute
   *
   * @param {Element} el
   * @return {boolean}
   */


  var alreadyBound = function alreadyBound(el) {
    return el.hasAttribute('data-tagular-uid');
  };
  /**
   * Bind events based on data source object.
   *
   * @param {object} config
   * @param {NodeList} config.elements
   * @param {object} config.data
   * @param {object=} config.settings
   * @param {boolean=} reload
   */


  var bind = (function (_ref) {
    var elements = _ref.elements,
      _ref$data = _ref.data,
      data = _ref$data === void 0 ? {} : _ref$data,
      _ref$settings = _ref.settings,
      settings = _ref$settings === void 0 ? {} : _ref$settings;
    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    if (!hasOwnProperty(data, '@type')) {
      log$5('Error: No tagular event ("@type") was specified.', {
        elements: elements,
        data: data,
        settings: settings
      });
      return;
    } // Bail early if no elements


    if (!elements || elements.length === 0) {
      return;
    }

    var type = data['@type'];
    var browserEvent = getBrowserEvent(type, settings);

    var _store$getState = store.getState(),
      uid = _store$getState.uid; // Update the stored data map.


    store.dispatch({
      type: MAP_DATA,
      data: data,
      uid: uid
    }); // Increment the uid.

    store.dispatch({
      type: INCREMENT_UID
    }); // If not defined, don't bind.

    if (!isString(browserEvent)) {
      log$5('Error: No browser event was specified.', {
        browserEvent: browserEvent,
        elements: elements,
        data: data,
        settings: settings,
        uid: uid
      });
      return;
    } // Loop over the elements and bind the events.


    Array.from(elements).forEach(function (element, index) {
      // If already bound, don't bind again.
      if (alreadyBound(element)) {
        // Don't log on reloads. That's annoying.
        if (!reload) {
          log$5('Element already has an event.', element);
        }

        return;
      } // Set some data-attributes


      element.setAttribute('data-tagular-event', type);
      element.setAttribute('data-tagular-uid', uid);
      element.setAttribute('data-tagular-index', index + 1); // TODO: handle different event types, and dispatch accordingly
      // TODO: delegate all events to document?

      switch (browserEvent) {
        case 'scroll':
        case 'view':
          observer(element, "".concat(type, ":").concat(uid), settings);
          break;

        case 'click':
        case 'contextmenu':
        case 'mousedown':
        case 'focus':
        case 'blur':
        case 'change':
        case 'touchcancel':
        case 'touchstart':
        case 'touchstop':
        case 'touchmove':
        case 'submit':
          element.addEventListener(browserEvent, function (event) {
            return setTimeout(function () {
              return clickHandler(event, settings, element);
            }, 0);
          }); // If a ProductClicked event...

          if (/ProductClicked/i.test(type)) {
            // Optionally add a ProductViewed event.
            if (hasOwnProperty(settings, 'addProductViewed') && settings.addProductViewed === true) {
              observer(element, "ProductViewed:".concat(uid), settings);
            } // Optionally append Cohesion attributes on mousedown.


            if (hasOwnProperty(settings, 'addParamsToHref') && !!settings.addParamsToHref) {
              element.addEventListener('mousedown', function () {
                return addParamsToHref(element, settings.addParamsToHref);
              });
            }
          } // Allow "viewed" events on anything...


          if (hasOwnProperty(settings, 'addViewEvent') && isSupportedViewEvent(settings.addViewEvent)) {
            observer(element, "".concat(settings.addViewEvent, ":").concat(uid), settings);
          }

          break;

        default:
          log$5('Event type not supported.', deepMerge({
            type: type,
            element: element
          }));
          break;
      }
    });
  });

  var log$6 = logger('parse');
  var parse$1 = (function (source) {
    var reload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    log$6('Binding events to elements...'); // Don't do anything if the source isn't an object.

    if (!isPlainObject(source)) {
      log$6('Error: Cannot process source data; it is not an object.', source);
      return;
    } // If not reloading, make sure to add the source to the sourceCache.
    // On reloads, the 'state.sourceCache' will be passed in as 'source'.


    if (!reload) {
      store.dispatch({
        type: SOURCE_CACHE,
        source: source
      });
    } // Then iterate over the sourceCache and (re)bind the elements found on the page.


    Object.entries(source).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        selector = _ref2[0],
        config = _ref2[1];

      var elements = document.querySelectorAll(selector);
      var data = hasOwnProperty(config, 'data') ? config.data : config;
      var settings = config.settings ? config.settings : {};
      bind({
        elements: elements,
        data: data,
        settings: settings
      }, reload);
    });
  });

  var log$7 = logger('init');
  /**
   * Loop and process array of sources
   */

  var processQueue = function processQueue() {
    var _store$getState = store.getState(),
      queue = _store$getState.queue;

    if (queue && queue.length > 0) {
      log$7('Processing queued sources.', queue.length);
      var source = queue[0];
      parse$1(source);
      store.dispatch({
        type: DEQUEUE
      });
      processQueue();
    }
  };
  /**
   * Setup all global event listener.
   *
   * @param {Event} event
   * @param {string=} eventType
   */


  var triggerBeam = function triggerBeam(event, eventType) {
    var context = event.target.closest('[data-tagular-uid]');
    var uid = context.getAttribute('data-tagular-uid');
    var type = eventType || context.getAttribute('data-tagular-event');
    var state = store.getState();
    var data = state.data[uid];

    if (!type || !data) {
      log$7('Error in triggerTrack:', {
        data: data,
        event: event,
        type: type
      });
      return;
    }

    track(type, data, context, true);
  };
  /**
   * Trigger CartViewed event.
   *
   * @param {Event} event
   * @return {function}
   */


  var triggerCartViewed = function triggerCartViewed(event) {
    return triggerBeam(event, 'CartViewed');
  };
  /**
   * Trigger ElementViewed event.
   *
   * @param {Event} event
   * @return {function}
   */


  var triggerElementViewed = function triggerElementViewed(event) {
    return triggerBeam(event, 'ElementViewed');
  };
  /**
   * Trigger FormViewed event.
   *
   * @param {Event} event
   * @return {function}
   */


  var triggerFormViewed = function triggerFormViewed(event) {
    return triggerBeam(event, 'FormViewed');
  };
  /**
   * Trigger ProductViewed event.
   *
   * @param {Event} event
   * @return {function}
   */


  var triggerProductViewed = function triggerProductViewed(event) {
    return triggerBeam(event, 'ProductViewed');
  };
  /**
   * Trigger ProductListViewed event.
   *
   * @param {Event} event
   * @return {function}
   */


  var triggerProductListViewed = function triggerProductListViewed(event) {
    return triggerBeam(event, 'ProductListViewed');
  };
  /**
   * Setup global event listeners.
   */


  var setupEventListeners = function setupEventListeners() {
    var _eventMap;

    log$7('Setting up global event listeners.');
    var eventMap = (_eventMap = {}, _defineProperty(_eventMap, BEAM, triggerBeam), _defineProperty(_eventMap, CART_VIEWED, triggerCartViewed), _defineProperty(_eventMap, ELEMENT_VIEWED, triggerElementViewed), _defineProperty(_eventMap, FORM_VIEWED, triggerFormViewed), _defineProperty(_eventMap, PRODUCT_VIEWED, triggerProductViewed), _defineProperty(_eventMap, PRODUCT_LIST_VIEWED, triggerProductListViewed), _eventMap); // For each event in the event list, setup the listener.

    Object.entries(eventMap).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        name = _ref2[0],
        trigger = _ref2[1];

      // Attempt to remove any existing event (sanity check).
      window.removeEventListener(name, trigger, true); // Add the event.

      window.addEventListener(name, trigger, true);
    });
  };
  /**
   * Initialize the library.
   */


  var init = (function () {
    var _store$getState2 = store.getState(),
      initialized = _store$getState2.initialized; // Check for features needing polyfills.


    log$7('Checking browser support...');
    var features = browserSupport();

    if (features.length > 1) {
      // eslint-disable-next-line no-console
      console.warn("Your browser needs polyfills for: \u201C".concat(features.join('”, “'), "\u201D"));
    } else {
      log$7('No polyfills needed!');
    }

    if (!initialized && hasOwnProperty(window, 'cohesion')) {
      window.cohesion('ready', function () {
        try {
          // Setup global event listeners
          setupEventListeners(); // Process anything in the queue

          processQueue(); // Mark the module as initialized

          store.dispatch({
            type: INITIALIZE
          }); // Show that the module has loaded.

          log$7('Initialized.');
        } catch (error) {
          log$7('Error: There was a problem initializing.');
          console.error(error.message); // eslint-disable-line no-console
        }
      });
    }
  });

  var vars = (function (vars) {
    store.dispatch({
      type: ADD_VARS,
      vars: vars
    });
  });

  var log$8 = logger('setup'); // Setup events from source data

  var setup$1 = (function (source) {
    var _store$getState = store.getState(),
      initialized = _store$getState.initialized;

    log$8('Beginning setup...'); // If initialized then bind the events, otherwise add to queue.

    if (initialized) {
      parse$1(source);
    } else {
      store.dispatch({
        type: ENQUEUE,
        source: source
      });
    }
  });

  var log$9 = logger('utils:request');
  var request = (function (url) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : noop;

    if (!isString(url)) {
      log$9('Cannot fetch URL. It is not a String.', url);
      return false;
    }

    return fetch(url).then(function (response) {
      if (!response.ok || response.status >= 200 && response.status < 400) {
        throw new Error('Network response was not ok.');
      }

      return response.json();
    }).then(function (data) {
      callback(data);
    }).catch(function (error) {
      log$9("There was an error processing: ".concat(url), error);
      console.error(error.message); // eslint-disable-line no-console
    });
  });

  var log$a = logger('start');
  var start = (function (source) {
    if (isString(source)) {
      // If source is a string, assume XHR is needed and setup on callback
      request(source, setup$1);
    } else if (isPlainObject(source)) {
      // If source is an object, begin setup immediately
      setup$1(source);
    } else {
      log$a('Source is not a valid string or object.', source);
    }
  });

  var log$b = logger('load');
  var load = (function (source) {
    log$b('Loading source.'); // If other parameters, loop and handle accordingly

    for (var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      rest[_key - 1] = arguments[_key];
    }

    if (rest.length > 0) {
      log$b.apply(void 0, ['Loading other parameters.'].concat(rest));
      rest.forEach(function (arg) {
        if (isPlainObject(arg)) {
          vars(arg);
        } else if (isString(arg)) {
          store.dispatch({
            type: SCRIPT_PATH,
            path: arg
          });
        }
      });
    } // Begin to process


    start(source);
  });

  var reload = (function () {
    var _store$getState = store.getState(),
      sourceCache = _store$getState.sourceCache;

    if (sourceCache) {
      parse$1(sourceCache, true);
    }
  });

  var beam = {
    init: init,
    load: load,
    reload: reload,
    track: track,
    vars: vars,
    version: "1.4.4"
  };

  if (typeof document !== 'undefined') {
    // Initialize on DOMContentLoaded.
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      beam.init();
    } else {
      document.addEventListener('DOMContentLoaded', beam.init);
    }
  }

  window._Beam = beam
  return beam;

})));
